module.exports = __webpack_public_path__ + "cf2a2ced7c626b83eed1ae73007b4c55.png";